document.addEventListener("DOMContentLoaded", function () {

  const mobileNav = document.querySelector(".faq-select");

  if (mobileNav) {
    mobileNav.addEventListener("change", function (e) {
      const selectedOption = this.value;
      const target = document.querySelector(selectedOption);

      if (target) {
        const offset = target.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    });
  }

  const faqNavLinks = document.querySelectorAll(".faq-nav li a");

  faqNavLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      e.preventDefault();

      const href = this.getAttribute("href");
      const target = document.querySelector(href);

      if (target) {
        const offset = target.getBoundingClientRect().top + window.pageYOffset - 170;
        window.scrollTo({
          top: offset,
          behavior: "smooth"
        });
      }
    });
  });

});
